import GerenciadorNFSeService from "@/services/GerenciadorNFSeService";

function normalizeError(error) {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim() !== "") {
    return { Message: data };
  }

  if (data) {
    return data;
  }

  if (typeof error === "string" && error.trim() !== "") {
    return { Message: error };
  }

  if (error?.message) {
    return { Message: error.message };
  }

  return { Message: "Nao foi possivel concluir a operacao." };
}

export const gerenciadorNFSe = {
  namespaced: true,
  state: {
    gerenciadorNFSe: {},
  },
  actions: {
    padroesDisponiveis({ commit }, payload) {
      return GerenciadorNFSeService.PadroesDisponiveis(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    transmitirNota({ commit }, payload) {
      return GerenciadorNFSeService.TransmitirNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    consultarNota({ commit }, payload) {
      return GerenciadorNFSeService.ConsultarNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    cancelarNota({ commit }, payload) {
      return GerenciadorNFSeService.CancelarNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    imprimirNota({ commit }, payload) {
      return GerenciadorNFSeService.ImprimirNota(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
    downloadXMLNFSe({ commit }, payload) {
      return GerenciadorNFSeService.DownloadXMLNFSe(payload).then(
        (result) => Promise.resolve(result),
        (error) => Promise.reject(normalizeError(error))
      );
    },
  },
  mutations: {},
};

export default gerenciadorNFSe;
